var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1506 15C54.2256 15.875 52.1506 16.45 50.0006 16.725C52.2006 15.4 53.9006 13.3 54.7006 10.775C52.6256 12.025 50.3256 12.9 47.9006 13.4C45.9256 11.25 43.1506 10 40.0006 10C34.1256 10 29.3256 14.8 29.3256 20.725C29.3256 21.575 29.4256 22.4 29.6006 23.175C20.7006 22.725 12.7756 18.45 7.50059 11.975C6.57559 13.55 6.05059 15.4 6.05059 17.35C6.05059 21.075 7.92559 24.375 10.8256 26.25C9.05059 26.25 7.40059 25.75 5.95059 25V25.075C5.95059 30.275 9.65059 34.625 14.5506 35.6C12.9774 36.0305 11.3258 36.0904 9.72559 35.775C10.4046 37.9062 11.7344 39.771 13.5281 41.1073C15.3218 42.4436 17.4892 43.1842 19.7256 43.225C15.9347 46.2261 11.2356 47.8483 6.40059 47.825C5.55059 47.825 4.70059 47.775 3.85059 47.675C8.60059 50.725 14.2506 52.5 20.3006 52.5C40.0006 52.5 50.8256 36.15 50.8256 21.975C50.8256 21.5 50.8256 21.05 50.8006 20.575C52.9006 19.075 54.7006 17.175 56.1506 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1b4029bbd2e42e3950453b7b2b23a399.svg";
export { ForwardRef as ReactComponent };